import { z } from 'zod';

import {
  optionalTimestamp,
  requiredArray,
  requiredString,
  RESET_TIMESTAMP_VALUE,
} from '@/shared/utils/validation';

export const userRoleLinkSchema = z.object({
  userId: requiredString(),
  userRoleId: requiredString(),
  expirationTimestamp: optionalTimestamp({ resettable: true }),
  objectVersion: z.number(),
});

export const updateUserRoleLinkInputSchema = z.object({
  links: requiredArray(userRoleLinkSchema),
});

export const updateUserRoleLinkRequiredExpirationInputSchema =
  updateUserRoleLinkInputSchema.superRefine((data, ctx) => {
    const validExpirationTimestamp = (timestamp: string | null) => {
      return (
        timestamp !== null &&
        timestamp !== undefined &&
        timestamp !== '' &&
        timestamp !== RESET_TIMESTAMP_VALUE
      );
    };
    const allLinkWithExpiration = data.links?.every((link) =>
      validExpirationTimestamp(link.expirationTimestamp),
    );
    if (!allLinkWithExpiration) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'All links must have an expiration date.',
      });
    }
  });
